import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["debug"]

  connect() {
    this.log("connected, visualViewport: " + !!window.visualViewport)

    if (window.visualViewport) {
      this.boundHandleResize = this.handleResize.bind(this)
      window.visualViewport.addEventListener("resize", this.boundHandleResize)
    }
  }

  disconnect() {
    if (window.visualViewport && this.boundHandleResize) {
      window.visualViewport.removeEventListener("resize", this.boundHandleResize)
    }
  }

  handleResize() {
    const keyboardHeight = window.innerHeight - window.visualViewport.height
    const keyboardOpen = keyboardHeight > 150

    this.log(`innerH: ${window.innerHeight}, vpH: ${Math.round(window.visualViewport.height)}, diff: ${Math.round(keyboardHeight)}, open: ${keyboardOpen}`)

    this.element.classList.toggle("keyboard-open", keyboardOpen)
  }

  log(message) {
    if (this.hasDebugTarget) {
      this.debugTarget.textContent = message
    }
  }
}
